import { createContext } from "react";

export const CreateTaskModalContext = createContext();